import React, { Component } from 'react';

export class AvisoPrivacidadSTAC extends Component {
    render() {
        return (
            <div id="aviso-texto" className="col-12">
                <div className="col-12">
                    <h5 style={{ fontWeight: "bold" }}>AVISO DE PRIVACIDAD, USO DE DATOS Y COOKIES</h5>
                    <p style={{ textAlign: "justify" }}>
                        En cumplimiento con la Ley Org&aacute;nica de Protecci&oacute;n de Datos Personales, el presente
                        aviso de privacidad tiene como prop&oacute;sito comunicarle el uso de los datos de Alumni
                        para mantenerlo informado sobre la Escuela Superior Polit&eacute;cnica del Litoral (ESPOL)
                        y brindar oportunidades para que contin&uacute;e involucrado en la vida y actividades de esta.
                        Esto incluye otorgar y comunicar beneficios, servicios con fines administrativos,
                        programas filantr&oacute;picos, educativos y comunitarios, invitaciones a eventos, boletines
                        informativos, entre otras actividades. Adem&aacute;s, de usar su informaci&oacute;n con fines
                        estad&iacute;sticos y para cumplir con la informaci&oacute;n requerida por entidades de acreditaci&oacute;n
                        y rankings nacionales e internacionales. Se dispone del formulario de actualización de datos en la página
                        web: <a href="https://alumni.espol.edu.ec" target="_blank">www.alumni.espol.edu.ec</a>.
                    </p>
                    <div style={{ textAlign: "justify" }}>
                        <p>Los datos personales que se recolectar&aacute;n mediante el formulario en l&iacute;nea son los siguientes:</p>
                        <ul>
                            <li>Nombre, datos de contacto y domicilio.</li>
                            <li>Datos de identificaci&oacute;n y nacionalidad.</li>
                            <li>Lugar y fecha de nacimiento.</li>
                            <li>Estado civil y sexo.</li>
                            <li>Auto identificaci&oacute;n de g&eacute;nero y etnia.</li>
                            <li>Datos del perfil de las redes sociales.</li>
                            <li>Informaci&oacute;n laboral e informaci&oacute;n acad&eacute;mica.</li>
                            <li>Otros datos que se determinen necesarios solicitar al graduado por medio del formulario oficial.</li>
                        </ul>
                    </div>
                </div>
                <div className="col-12">
                    <p style={{ textAlign: "justify" }}>
                        A todos quienes autoricen el uso de sus datos por medio del formulario oficial, se le enviar&aacute; mensajes oportunos,
                        relevantes y apropiados a trav&eacute;s de los diferentes medios de comunicaci&oacute;n de ESPOL. Se dar&aacute; acceso a los datos
                        personales de los alumni a las unidades, &aacute;reas o direcciones de la ESPOL y a sus fundaciones, sociedades o empresas
                        p&uacute;blicas polit&eacute;cnicas. Usted puede optar por no recibir comunicaciones de Alumni ESPOL en cualquier momento poni&eacute;ndose
                        en contacto con alumni@espol.edu.ec
                    </p>
                </div>
                <br />
                <div className="col-12">
                    <h5 style={{ fontWeight: "bold" }}>SOBRE EL USO DE COOKIES:</h5>
                    <div style={{ textAlign: "justify" }}>
                        <p>
                            Una cookie es un peque&ntilde;o fichero de texto que se almacena en su navegador cuando visita cualquier página web.
                            Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa p&aacute;gina. Las cookies
                            suelen almacenar informaci&oacute;n de car&aacute;cter t&eacute;cnico, preferencias personales, personalizaci&oacute;n de contenidos,
                            estad&iacute;sticas de uso, enlaces a redes sociales, acceso a cuentas de usuario, etc. El objetivo de la cookie es
                            adaptar el contenido de la web a su perfil y necesidades, sin cookies los servicios ofrecidos por cualquier
                            p&aacute;gina se ver&iacute;an mermados notablemente.
                        </p>
                        <p>
                            El sitio web de alumni utiliza las siguientes cookies propias:
                        </p>
                        <ul>
                            <li>
                                Cookies de sesi&oacute;n, para garantizar que los usuarios que escriban comentarios en el blog sean humanos
                                y no aplicaciones automatizadas. De esta forma se combate el spam.
                                </li>
                        </ul>
                        <p>
                            El sitio web de alumni utiliza las siguientes cookies de terceros:
                        </p>
                        <ul>
                            <li>
                                Google Analytics: Almacena cookies para poder elaborar estad&iacute;sticas sobre el tr&aacute;fico y volumen de
                                visitas de esta web. Al utilizar este sitio web est&aacute; consintiendo el tratamiento de informaci&oacute;n
                                acerca de usted por Google. Por tanto, el ejercicio de cualquier derecho en este sentido deber&aacute;
                                hacerlo directamente con Google.
                                </li>
                            <li>
                                Redes sociales: Cada red social utiliza sus propias cookies para que usted pueda pinchar en botones
                                del tipo Me gusta o Compartir.
                                </li>
                        </ul>
                        <p>
                            En cualquier momento podr&aacute; ejercer su derecho de desactivaci&oacute;n o eliminaci&oacute;n de cookies de este sitio web.
                            Estas acciones se realizan de forma diferente en funci&oacute;n del navegador que est&eacute; utilizando.
                        </p>
                        <ul>
                            <li>
                                Esta web ni sus representantes legales se hacen responsables por el contenido y la veracidad de
                                las pol&iacute;ticas de privacidad que puedan tener los terceros mencionados en esta pol&iacute;tica de cookies.
                                </li>
                            <li>
                                Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe
                                efectuar su derecho a eliminaci&oacute;n o desactivaci&oacute;n de estas. Ni esta web ni sus representantes legales
                                pueden garantizar la correcta o incorrecta manipulaci&oacute;n de las cookies por parte de los mencionados
                                navegadores.
                                </li>
                            <li>
                                En algunos casos es necesario instalar cookies para que el navegador no olvide su decisi&oacute;n de no
                                aceptaci&oacute;n de estas.
                                </li>
                            <li>
                                En el caso de las cookies de Google Analytics, esta empresa almacena las cookies en servidores
                                ubicados en Estados Unidos y se compromete a no compartirla con terceros, excepto en los casos en
                                los que sea necesario para el funcionamiento del sistema o cuando la ley obligue a tal efecto.
                                Seg&uacute;n Google no guarda su direcci&oacute;n IP. Google Inc. es una compa&ntilde;ía adherida al Acuerdo de Puerto
                                Seguro que garantiza que todos los datos transferidos serán tratados con un nivel de protección
                                acorde a la normativa europea.
                                </li>
                        </ul>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>VERACIDAD DE LOS DATOS</h5>
                        <p style={{ textAlign: "justify" }}>
                            Usted garantiza que los datos personales facilitados son veraces y se compromete a comunicar cualquier
                            actualizaci&oacute;n de los mismos. Tambi&eacute;n garantiza que, salvo error tipogr&aacute;fico, toda la informaci&oacute;n facilitada
                            corresponde con su situaci&oacute;n real, que est&aacute; al d&iacute;a y es exacta, siendo el &uacute;nico responsable de la inexactitud o
                            falsedad de los datos facilitados y de los perjuicios que pueda causar por ello.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>ACEPTACI&Oacute;N Y CONSENTIMIENTO</h5>
                        <p style={{ textAlign: "justify" }}>
                            Usted declara haber sido informado de las condiciones indicadas en este aviso, y consiente expresamente al
                            tratamiento de sus datos personales por parte de la ESPOL, en la forma y para las finalidades indicadas en el
                            presente Aviso de privacidad de datos, incluyendo el uso de cookies.
                        </p>
                    </div>
                </div> 
            </div>
        );
    }
}

export default AvisoPrivacidadSTAC;